export default __webpack_public_path__ + "static/media/confirm-order.7341dd32.svg";